import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['index','date','title','message','action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  enterpriseSelect: number = 0;
  headquarterSelect: number = 0;
  page: number = 1;
  searchText: string = '';
  pageEvent: PageEvent;
  pageIndex: number = 0;
  length: number = 0;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  pageSize: number = AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION;
  timer:any;
  timeoutVal = 800;

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private notificationService: NotificationService,) {
    document.getElementById("titleHeaderNav").innerHTML = '<span class="font-weight-bold">Mis Notificaciones</span>';
    this.setLS();
   }

   getServerData(event?: PageEvent) {
    this.page = event.pageIndex + 1;
    this.getList();
  }

  applyPressFilter(event: Event) {
    var _this = this;
    window.clearTimeout(_this.timer);
  }

   setLS(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.paginator._intl.itemsPerPageLabel = '';
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.headquarterSelect = (+localStorage.getItem(AppConstants.Session.HEADQUARTER));
    this.getList();
  }

  getList(){
    var filter = {
      Page: this.page,
      Rows: AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION,
      IdEnterprise: this.enterpriseSelect,
      IdHeadquarter: this.headquarterSelect,
      IdUser: [localStorage.getItem(AppConstants.Session.USERID)],
      Filter: this.searchText
    };
    this.spinner.show();
    this.notificationService.getList(filter).subscribe((_) => {
      if(_.error == null){
        this.dataSource = new MatTableDataSource(_["rows"]);
        this.pageIndex = +_["page"]-1;
        this.length = _["total"];
      }
      this.spinner.hide();
    });
  }

  redirect(r){
    this.router.navigate([r.redirect], { queryParams: {id: r.idRedirect}});
  }

  checkItem(item){
    this.spinner.show();
    this.notificationService.checked(item.id).subscribe((_) => {
      item.checked = 1;
      this.spinner.hide();
    });
  }

  checkedAll(){
    this.spinner.show();
    this.notificationService.checkedAll().subscribe((_) => {
      this.getList();
    });
  }

  applyUpFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchText = filterValue.trim().toLowerCase();
      var _this = this;
      window.clearTimeout(_this.timer);
        _this.timer = window.setTimeout(() => {
            _this.page = 1;
            _this.paginator.pageIndex = 0;
            _this.getList();
          }, _this.timeoutVal);
  }

}
